import * as React from 'react';
import { Textarea } from '@kajabi/sage-react';

import useEditResultItem from 'common/components/CopyMagic/hooks/useResultEditItem';
import { contentAssistantSchema } from 'common/components/CopyMagic/shared/validationSchema';

const attributePath = ['content'];
const ContentInput = () => {
  const { inputName, onChangeHandler, onBlurHandler, value, errorMessage } = useEditResultItem({
    attributePath,
    validationSchema: contentAssistantSchema,
  });

  return (
    <Textarea
      name={inputName}
      id={inputName}
      data-testid={inputName}
      onChange={onChangeHandler}
      onBlur={onBlurHandler}
      value={value}
      message={errorMessage}
      hasError={!!errorMessage.length}
      rows={10}
    />
  );
};

export default ContentInput;
